export function* map<T, R>(gen: Iterable<T>, f: (x: T) => R): Iterable<R> {
  for (const x of gen) yield f(x);
}

export function fold<T, R>(gen: Iterable<T>, f: (acc: R, x: T) => R, init: R): R {
  let acc = init;

  for (const x of gen) acc = f(acc, x);

  return acc;
}

export function* filter<T>(gen: Iterable<T>, f: (x: T) => boolean): Iterable<T> {
  for (const x of gen) if (f(x)) yield x;
}

export function some<T>(gen: Iterable<T>, f: (x: T) => boolean): boolean {
  for (const x of gen) if (f(x)) return true;

  return false;
}

export function find<T>(gen: Iterable<T>, which?: (x: T) => boolean): T | undefined {
  for (const x of gen) if (!which || which(x)) return x;

  return undefined;
}

export function count<T>(gen: Iterable<T>): number {
  let n = 0;

  for (const _ of gen) n++;

  return n;
}

export function first<T>(gen: Iterable<T>): T | undefined {
  for (const x of gen) return x;
}

export function* flat<T>(gen: Iterable<Iterable<T>>): Iterable<T> {
  for (const x of gen) yield* x;
}

export function flatMap<T, R>(gen: Iterable<T>, f: (x: T) => Iterable<R>): Iterable<R> {
  return flat(map(gen, f));
}
